import { render, staticRenderFns } from "./CheckExaminationPaper.vue?vue&type=template&id=ad644cc6&"
import script from "./CheckExaminationPaper.vue?vue&type=script&lang=js&"
export * from "./CheckExaminationPaper.vue?vue&type=script&lang=js&"
import style0 from "./CheckExaminationPaper.vue?vue&type=style&index=0&id=ad644cc6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports